export default __webpack_public_path__ + "static/media/delete icon.e46b5eba.svg";